import React from "react";
import * as Mui from "@mui/material";
import { DashboardLayout } from "component/layout/dashboard";
import { ColdFusionIframe } from "component/shared/iframe/coldfusion";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";

interface Props extends PageProps, Router.RouteComponentProps {
}

class Component extends React.Component<Props> {

	public render() {
		const { user } = this.props;
		const title = "Change Username & Password";
		return (
			<DashboardLayout
				/**
				 * This is a legacy setting which will be replaced with the agent and user page "Change Password".
				 * once all logins are agent, we should no longer need this page. 
				 */
				permitted={user.type.agent && user.permissions.modifyCredentials}
				title={title}
				header={
					<Mui.Typography variant="h1">
						<FeatherIcon>
							<Icons.Settings />
						</FeatherIcon>
						{title}
					</Mui.Typography>
				}
				iframe={<ColdFusionIframe url="/agentloginsettings.cfm" />}
			/>
		);
	}

}

export const AgentPassword = Component;